import { createPipeType } from '@angular/compiler/src/render3/r3_pipe_compiler';
import { LOCALE_ID, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: '3fd6209b-ac1f-48de-ab99-86cd77049ec9',
    /* ...Other Configuration Options... */
    autoTrackPageVisitTime: true,
    enableAutoRouteTracking: true,
    isCookieUseDisabled: true,
  }
});

appInsights.loadAppInsights();
appInsights.trackPageView();


if (environment.production) {
  enableProdMode();
}

//adding goodle map  autocomplete code

var enableGoogleKey = true;
var google_api_key = environment.api.googlemapapi;

if (enableGoogleKey) {

  var script = document.createElement('script');
  if (google_api_key != '') {
    script.id = "uniqueMapIDD"
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + google_api_key + '&libraries=places&callback=initAutocomplete';
    $("head").append(script.outerHTML);
    sessionStorage.setItem("google", "true");
  } else {
    sessionStorage.setItem("google", "false");
  }
} else {
  sessionStorage.setItem("google", "false");
}
platformBrowserDynamic().bootstrapModule(AppModule, {
  providers: [{ provide: LOCALE_ID, useValue: 'en-CA' }]
})
  .catch(err => console.error(err));

window['initAutocomplete'] = function () {
}


